/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTank: {
  name: 'tank';
  data: string;
} = {
  name: 'tank',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 .5a5.5 5.5 0 0 0-2.491 10.405A.503.503 0 0 0 3.5 11v3.5H1a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1h-2.5V11a.505.505 0 0 0-.009-.095A5.5 5.5 0 0 0 10 .5H6Zm-.5 1.027a4.5 4.5 0 0 0 0 8.946V1.527Zm1 1.973v-2h3v2h-3Zm0 1v3h3v-3h-3Zm0 4v2h3v-2h-3Zm-.5 3c-.52 0-1.023-.072-1.5-.207V14.5h7v-3.207c-.477.135-.98.207-1.5.207H6ZM14.5 6a4.5 4.5 0 0 1-4 4.473V1.527A4.5 4.5 0 0 1 14.5 6Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
